export default async function shouldRedirectToProfiler() {
  // Profiling step removed: never redirect to profile for completion
  return false;
}
